import React, { useState, useEffect } from "react";
import "./Login.css";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/HOA Owl Logo.svg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import { Provider,useDispatch, useSelector } from "react-redux";
import { userLoginApi } from "../../../Services/Login/LoginApi/loginApi";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CommunityOwner, HomeOwner, SuperAdmin } from "../../../Utils/Constant";
import chevronleft from "../../../images/chevronleft.svg";

function LoginComponent() {
  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions
  const [showPassword, setShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const userType = localStorage.getItem("user_type");
    
    
    if (accessToken && userType) {
      switch (userType) {
        case CommunityOwner:
          navigate("/user/chatboat");
          break;
        // case SuperAdmin:
        //   navigate("/super-admin/dashboard");
        //   break;
        case HomeOwner:
          navigate("/home-owner-admin/dashboard");
          break;
        default:
          break;
      }
    }
  }, []);

  // useEffect(() => {
  //   // Load saved password from local storage
  //   const savedPassword = localStorage.getItem("password");
  //   const savedEmail = localStorage.getItem("email");
  //   if (savedPassword && savedEmail) {
  //     setPassword(savedPassword);
  //     setEmail(savedEmail);
  //     setRememberPassword(true);
  //   }
  // }, []);

  const handleRememberChange = (e) => {
    setRememberPassword(e.target.checked);
  };

  // Handler to toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  // Prevent default behavior for mouse down event
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  // Validation function
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!email) {
      formErrors.email = "Email is required.";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      formErrors.email = "Invalid email format.";
      isValid = false;
    }

    if (!password) {
      formErrors.password = "Password is required.";
      isValid = false;
    } else if (password.length < 6) {
      formErrors.password = "Password must be at least 6 characters long.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  }; // Closing brace added here

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (errors.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault(); //  Ensure form doesn't reload
  
    if (isSubmitting) return; // Prevent multiple submissions
    if (!validateForm()) return;
  
    setIsSubmitting(true);
  
    if (rememberPassword) {
      localStorage.setItem("password", password);
      localStorage.setItem("email", email);
    } else {
      localStorage.removeItem("password");
      localStorage.removeItem("email");
    }
  
    try {
      const response = await dispatch(userLoginApi({ email, password })).unwrap();
      
  
      if (response?.status === 403) { //  If user is inactive
        toast.error("Your account is deactivated. Please contact support.");
        setIsSubmitting(false);
        return; //  Stop execution and prevent reload
      }
  
      if (response?.status === 200) {
        const { token, user_type, user_id, first_name, last_name, email, is_active , is_privacy_policy_accepted} = response.data;
  
        if (!is_active) { //  Prevent navigation if inactive
          toast.error("Your account is deactivated. Please contact support.");
          setIsSubmitting(false);
          return; //  Stop execution and prevent reload
        }
     console.log(is_privacy_policy_accepted , "is_privacy_policy_accepted ==========================>");
        localStorage.setItem("accessToken", token?.access);
        localStorage.setItem("email", email);
        localStorage.setItem("user_type", user_type);
        localStorage.setItem("access_token", token?.access);
        localStorage.setItem("user_id", user_id);
        localStorage.setItem("user_first_name", first_name);
        localStorage.setItem("user_last_name", last_name); 
        localStorage.setItem("read_privacy", localStorage.getItem("read_privacy") == "true" ? true :  false ); //  Store active status
        localStorage.setItem("is_privacy_policy_accepted", is_privacy_policy_accepted === true ? "true" : "false" ); //  Store privacy policy status
        navigate("/user/chatboat", { state: { is_privacy_policy_accepted } }); //  Navigate only if active user
      } else {
        toast.error(response?.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error(err?.message || "Login failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const handleSignuproute = () => {
    navigate("/signupone");
  };

  // const handleBackClick = () => {
  //   navigate("/");
  // };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  return (
    <>
      <section className="login-page-one login-box">
        <div className="container-fluid p-0 m-0">
          <div className="row m-0 loginpage">
            <div className="col-md-6">
              <div className="login-right-block logo-left-block mb-0">
                <div className="login-logoimg text-center">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  />
                </div>
              </div>
              <div className="banner-contents">
                <div className="banner-image">
                  {/* <img src={banner_img} alt="banner-image" /> */}
                  <div className="text-overlay">
                    {/* <h5>Welcome Back!</h5> */}
                    {/* <p>
                      Elevate your business insights with precision. Log in to
                      discover and refine your Ideal Customer Profiles
                      effortlessly.
                    </p> */}
                    <p>Creating customizable solutions for overall wellness</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 login-cols-block">
              <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center">
                  <Link to="/">
                    <img
                      src={login_logo}
                      alt="login-logo"
                      className="login_logo_img"
                    />
                  </Link>
                </div>
                {/* <div className="back-btn">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div> */}
              </div>
              <div className="login-page-area">
                <div className="login-information log-in">
                  {/* <h1 className="text-center">Log In</h1> */}
                  <div className="form-login text-left">
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-email">
                        Email <span>*</span>
                      </InputLabel>
                      <Input
                        className="email-input-box"
                        id="standard-adornment-email"
                        type="email"
                        placeholder="Email"
                        onChange={handleEmailChange}
                        value={email}
                        onKeyDown={handleKeyDown}
                      />
                      {errors.email && (
                        <p className="error-text">{errors.email}</p>
                      )}
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-password">
                        Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="standard-adornment-password"
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        onChange={handlePasswordChange}
                        value={password}
                        onKeyDown={handleKeyDown}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.password && (
                        <p className="error-text">{errors.password}</p>
                      )}
                    </div>
                    <div className="mb-4 checkbox d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          {/* <Checkbox
                            {...label}
                            checked={rememberPassword}
                            onChange={handleRememberChange}
                            className="check-box"
                          /> */}
                        </div>
                        {/* <span className="password-text">Remember Password</span> */}
                      </div>
                      <div className="forgot-pw">
                        <Link to="/forgot-password">Forgot Password</Link>
                      </div>
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Sign In"}
                      </Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      {/* <p>
                        Don&apos;t have an account?{" "}
                        <a href="" onClick={handleSignuproute}>
                          Sign Up
                        </a>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default LoginComponent;
